import { useState } from "react";
import {
  Typography,
  Box,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { capitalize } from "../../../config/leadStatus";

export const StatusDropdown = ({
  value,
  options,
  getStyles,
  onSelect,
  showDot = false,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const styles = getStyles(value);
  const item = options?.find ? options.find((o) => o.key === value) : null;
  const displayLabel = item
    ? item.label || value
    : styles.label || value || "—";

  return (
    <>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          px: 1,
          py: 0.5,
          borderRadius: "6px",
          cursor: "pointer",
          bgcolor: styles.bgcolor,
          transition: "all 0.15s ease",
          "&:hover": { opacity: 0.85 },
        }}
      >
        {showDot && (
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: styles.color,
              flexShrink: 0,
            }}
          />
        )}
        <Typography
          sx={{
            fontSize: 10,
            fontWeight: 700,
            color: styles.color,
            textTransform: "uppercase",
          }}
        >
          {displayLabel}
        </Typography>
        <KeyboardArrowDownIcon
          sx={{ fontSize: 14, color: "#64748B", ml: 0.25 }}
        />
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            mt: 0.5,
            minWidth: 160,
            maxHeight: 280,
            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            borderRadius: 2,
            bgcolor: "#fff",
            "& .MuiMenuItem-root": { fontSize: 13, py: 1 },
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#fff",
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: theme.palette.primary.main,
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
            scrollbarWidth: "thin",
            scrollbarColor: `${theme.palette.primary.main} #fff`,
          },
        }}
      >
        {options
          ?.map((option) => option.key)
          .map((option) => {
            const optStyles = getStyles(option);
            const optItem = options?.find
              ? options.find((o) => o.key === option)
              : null;
            const menuLabel = optItem
              ? optStyles.label || capitalize(option)
              : optStyles.label || capitalize(option);
            return (
              <MenuItem
                key={option}
                onClick={() => {
                  onSelect?.(option);
                  setAnchorEl(null);
                }}
                selected={option === value}
                sx={{ "&.Mui-selected": { bgcolor: optStyles.bgcolor } }}
              >
                {optStyles.icon && (
                  <ListItemIcon sx={{ color: optStyles.color, minWidth: 32 }}>
                    {optStyles.icon}
                  </ListItemIcon>
                )}
                {showDot && !optStyles.icon && (
                  <ListItemIcon sx={{ minWidth: 24 }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        bgcolor: optStyles.color,
                      }}
                    />
                  </ListItemIcon>
                )}
                <ListItemText
                  primary={menuLabel}
                  sx={{ "& .MuiTypography-root": { fontWeight: 500 } }}
                />
              </MenuItem>
            );
          })}
      </Menu>
    </>
  );
};
